import { render, staticRenderFns } from "./comment-question.vue?vue&type=template&id=8e450da6"
import script from "./comment-question.vue?vue&type=script&lang=js"
export * from "./comment-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports